export const DASHBOARD_THEME_COOKIE = "blacksmith_dashboard_theme";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/**
 * Cookie string carrying the resolved dashboard theme to backend-rendered
 * pages on other `*.blacksmith.sh` origins (OAuth popups, email verification).
 * Nothing else reads this cookie. Off `blacksmith.sh` (localhost) it stays
 * host-only.
 */
export function dashboardThemeCookie(
  theme: "light" | "dark",
  location: Pick<Location, "hostname" | "protocol"> = window.location,
): string {
  const host = location.hostname.toLowerCase();
  const shared = host === "blacksmith.sh" || host.endsWith(".blacksmith.sh");
  const parts = [
    `${DASHBOARD_THEME_COOKIE}=${theme}`,
    "path=/",
    `max-age=${ONE_YEAR_SECONDS}`,
    "SameSite=Lax",
  ];
  if (shared) parts.push("domain=.blacksmith.sh");
  if (location.protocol === "https:") parts.push("Secure");
  return parts.join("; ");
}
